import { formatDocumentUploadMetadata } from '../../utils/formatters'
import type { ReimbursementDocumentReviewStatus } from '../../types/reimbursementFormTypes'

export type DocumentReviewMetadataProps = {
  uploadedAt?: Date
  uploadedBy?: string
  status?: ReimbursementDocumentReviewStatus | 'pending' | 'rejected'
  reviewedAt?: Date
  reviewedBy?: string
  rejectionReason?: string
  reclassifiedFrom?: string
  reclassifiedAt?: Date
  reclassifiedBy?: string
  className?: string
}

function formatReviewMetadata(date?: Date, user?: string) {
  if (!date) return ''
  return formatDocumentUploadMetadata(date, user)
}

export function DocumentReviewMetadata({
  uploadedAt,
  uploadedBy,
  status,
  reviewedAt,
  reviewedBy,
  rejectionReason,
  reclassifiedFrom,
  reclassifiedAt,
  reclassifiedBy,
  className,
}: DocumentReviewMetadataProps) {
  const isIncomplete = status === 'incomplete' || status === 'rejected'

  return (
    <div className={className}>
      {rejectionReason && isIncomplete ? (
        <p className="mt-1 text-xs font-medium text-red-700">Reason: {rejectionReason}</p>
      ) : null}
      {uploadedAt ? (
        <p className="mt-1 text-xs italic text-gray-500">
          Uploaded {formatReviewMetadata(uploadedAt, uploadedBy)}
        </p>
      ) : null}
      {reviewedAt && reviewedBy && status && (status === 'approved' || isIncomplete) ? (
        <p className="text-xs italic text-gray-500">
          {status === 'approved' ? 'Approved' : 'Marked incomplete'} on{' '}
          {formatReviewMetadata(reviewedAt, reviewedBy)}
        </p>
      ) : null}
      {reclassifiedFrom && reclassifiedAt ? (
        <p className="text-xs italic text-blue-600">
          Reclassified from &quot;{reclassifiedFrom}&quot; on{' '}
          {formatReviewMetadata(reclassifiedAt, reclassifiedBy)}
        </p>
      ) : null}
    </div>
  )
}
